import { useState } from "react";
import axios from "axios";
import { API } from "../../context/AuthContext";
import { toast } from "sonner";
import { QrCode, CheckCircle2 } from "lucide-react";

export default function Missions({ missions, done, requireLogin, onDone }) {
  const [codes, setCodes] = useState({});
  const redeem = async (m) => {
    if (!requireLogin()) return;
    try {
      const { data } = await axios.post(`${API}/paddock/missions/${m.id}/redeem`, { code: codes[m.id] || "" });
      toast.success(`Missione completata! +${data.points} punti`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail === "Wrong code" ? "Codice errato" : e.response?.data?.detail || "Errore"); }
  };
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
      {missions.length === 0 && <div className="rl-card p-8 text-slate-500 col-span-full text-center">Nessuna missione attiva.</div>}
      {missions.map(m => {
        const completed = done.includes(`MISSION:${m.id}`);
        return (
          <div key={m.id} className="rl-card p-6 flex flex-col" data-testid={`mission-card-${m.id}`}>
            {m.sponsor && <div className="pill-badge pill-amber self-start mb-3">{m.sponsor.toUpperCase()}</div>}
            <div className="font-display font-black text-2xl mb-1 flex items-center gap-2"><QrCode className="w-5 h-5 text-[#00F0FF]" /> {m.title}</div>
            <div className="text-sm text-slate-400 mb-3">{m.description}</div>
            <div className="text-xs font-mono-rl text-[#FF9F0A] mb-4">{m.points} PTS</div>
            {completed ? (
              <div className="mt-auto flex items-center gap-2 text-[#30D158] text-sm font-mono-rl"><CheckCircle2 className="w-4 h-4" /> COMPLETATA</div>
            ) : (
              <div className="mt-auto flex gap-2">
                <input value={codes[m.id] || ""} onChange={e => setCodes({ ...codes, [m.id]: e.target.value.toUpperCase() })}
                  placeholder="CODICE QR" data-testid={`mission-code-${m.id}`}
                  className="flex-1 bg-black/40 border border-white/10 rounded-md px-3 py-2 text-sm font-mono-rl outline-none focus:border-[#FF1E27]" />
                <button className="btn-outline-rl !py-2 !px-4 text-xs" onClick={() => redeem(m)} data-testid={`mission-redeem-${m.id}`}>RISCATTA</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
